<script>
    /**
     * SPDX-FileCopyrightText: 2012-2026 Open Assessment Technologies S.A.
     * Copyright (C) 2026 (original work) Open Assessment Technologies S.A.
     *
     * SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-TAO-Commercial-License
     */

    /**
     * @typedef {Object} Props
     * @property {string} [title]
     */
    /** @type {Props} */
    let { title = '' } = $props();
</script>

<style>
    .item-header {
        padding: 3.5rem 4rem;
        margin: 4rem 0;
        background: var(--color-bg-info);

        & h3 {
            font-size: var(--fontsize-heading-l);
            margin: 0;
        }
    }
</style>

<header class="item-header">
    <h3>{title}</h3>
</header>
